import(/* webpackMode: "eager" */ "/vercel/path0/app/ai-proposal-generator/page.tsx");
